import React, { useEffect,useState } from 'react'
import Services from './../services/services';
import ShopHeader from './../shop/ShopHeader';
import Steps from './../basics/Steps';
import { useNavigate, useParams } from 'react-router-dom';
import Notification from './../basics/Notification';

const PassengerList = (props: any) => {

  const services = new Services();

  const [reservations, setReservations] = useState([{ orderItem: '', ticket: '', ticket_state: 'err', ticket_data_state: 'err', ticket_message: "Chybějící nebo chybná letenka" , name: '', surname: '', weight : ''}])

  const [reservationsList, setReservationsList]: any = useState([]);

  const [term, setTerm]: any = useState([]);

  const [reservant, setReservant] = useState({ firstname: '', lastname: '', email: '', phone: '', flynumber: {} })

  const [notification, setNotification] = useState<any>();

  const [weight, setWeight] = useState<any>(0);

  const [buttonState, setButtonState] = useState<any>('');

  const [validator, setValidator] = useState<any>({
    phone: '',
    phone_validity: false,
    email: '',
    email_validity: false,
  });

  const [reservantState, setReservantState] = useState<any>({
    reservant_state: 'err', reservant_message: 'Vyplňte kontakt rezervujícího'
  });

  const navigate = useNavigate();

  let {id} = useParams();

  useEffect(()=>{

    if (localStorage.getItem('bk_reservant') !== null) {
      setReservations(JSON.parse(String(localStorage.getItem('bk_reservations'))))
    }

    if (localStorage.getItem('bk_reservant') !== null) {
      setReservant(JSON.parse(String(localStorage.getItem('bk_reservant'))))
    }

    services.getTerm(id).then((value: any) => {

      setTerm(value)

    })

  }, [])

  useEffect(()=>{

    localStorage.setItem('bk_reservations', JSON.stringify(reservations));

    console.log(reservations)

    let newWeight = 0;

    let maxWeight = Number(term.weight) - Number(term.weightUsed);

    console.log(maxWeight)

    reservations.forEach((element) => {

      newWeight = newWeight + Number(element['weight']);

    })

    setWeight(newWeight);

    if(newWeight > maxWeight){
      setNotification(<Notification text={ "Překročen váhový limit"}/>)
      setButtonState('disabled');
    }else{
      setButtonState('');
    }

  }, [reservations])

  useEffect(()=>{

    console.log("hmotnost", weight)

  }, [weight])

  useEffect(()=>{

    let newReservant = {...reservant}

    let newReservantState = {...reservantState}

    let newValidator = {...validator}

    if(newReservant['phone'].match(/^\+?[1-9][0-9]{11}$/) || newReservant['phone'].match(/^[0-9]{9}$/)){
      newValidator['phone'] = <small className="text-success">Telefon je ve správném formátu</small>
      newValidator['phone_validity'] = true
    }else{
      newValidator['phone'] = <small className="text-danger">Telefon zatím není ve správném formátu</small>
      newValidator['phone_validity'] = false
    }

    if(newReservant['email'].match(/^\S+@\S+\.\S+$/)){
      newValidator['email'] = <small className="text-success">Email je ve správném formátu</small>
      newValidator['email_validity'] = true
    }else{
      newValidator['email'] = <small className="text-danger">Email zatím není ve správném formátu</small>
      newValidator['email_validity'] = false
    }

    let message_list: Array<string> = [];

    if( newReservant['firstname'] == '' ){
      message_list.push('jméno')
    }if( newReservant['lastname'] == '' ){
      message_list.push('příjmení')
    }if( newReservant['email'] == '' ){
      message_list.push('email')
    }if( newReservant['phone'] == '' ){
      message_list.push('telefon')
    }

    if( message_list.length == 0 && newValidator['email_validity'] && newValidator['phone_validity']){
      newReservantState['reservant_message'] = <span className="text-success">Rezervující je v pořádku</span>
      newReservantState['reservant_state'] = 'ok'
    }else{
      newReservantState['reservant_message'] = <span className="text-danger">Je nutné doplnit {message_list.join()}</span>
      newReservantState['reservant_state'] = 'err'
    }

    setReservantState(newReservantState)
    setValidator(newValidator)


  }, [reservant])

  // UnCorrect

  let handleTicket = (i: number, e: any ) => {

    console.log('ticket handled');

    let newReservations = [...reservations];

    let duplicate = false;

    newReservations.forEach((element) => {

      if( element.ticket_state == 'ok' && element.ticket == e.target.value ){

        duplicate = true;

      }

    })

    newReservations[i]['ticket'] = e.target.value

    if( !duplicate ){

    services.checkFlyNumber( e.target.value, id ).then((value: any) => {

      console.log('val: '+value);

      if(value !== undefined){

        newReservations[i]['orderItem'] = value.id
        newReservations[i]['name'] = value.firstname
        newReservations[i]['surname'] = value.lastname
        newReservations[i]['weight'] = value.weight
        newReservations[i]['ticket_state'] = 'ok'

        if(value.firstname !== null && value.lastname !== null && value.weight !== null ){
          newReservations[i]['ticket_data_state'] = 'ok'
          newReservations[i]['ticket_message'] = 'Připraveno k rezervaci'
        }else{
          newReservations[i]['ticket_data_state'] = 'err'
          newReservations[i]['ticket_message'] = 'Rezervace není kompletně vyplňena'
        }

        setReservations(newReservations)

      }else{

        newReservations[i]['name'] = ''
        newReservations[i]['surname'] = ''
        newReservations[i]['weight'] = ''
        newReservations[i]['ticket_state'] = 'err'
        newReservations[i]['ticket_message'] = 'Chybějící nebo chybná letenka'

        setReservations(newReservations)

      }

    })
    }else{

      console.log('Letenka již existuje')
      newReservations[i]['ticket_message'] = 'Letenka již v tomto seznamu existuje'
      newReservations[i]['ticket_state'] = 'err'

      setReservations(newReservations)

    }

  }

  let handleChange = (i: number, e: any ) => {

    let newReservations = [...reservations];

    if( e.target.name == 'name' ){
      newReservations[i]['name'] = e.target.value
      newReservations[i]['ticket_data_state'] = 'ok'
    }if( e.target.name == 'surname' ){
      newReservations[i]['surname'] = e.target.value
      newReservations[i]['ticket_data_state'] = 'ok'
    }if( e.target.name == 'weight' ){
      newReservations[i]['weight'] = e.target.value
      newReservations[i]['ticket_data_state'] = 'ok'
    }

    if(newReservations[i]['name'] !== '' && newReservations[i]['surname'] !== '' && newReservations[i]['weight'] !== '' && newReservations[i]['ticket'] !== '' && newReservations[i]['ticket_state'] == 'ok' && newReservations[i]['ticket_data_state'] == 'ok' ){
      newReservations[i]['ticket_data_state'] = 'ok'
      newReservations[i]['ticket_message'] = 'Připraveno k rezervaci'
    }else{
      newReservations[i]['ticket_data_state'] = 'err'
      newReservations[i]['ticket_message'] = 'Rezervace není kompletně vyplňena'
    }

    setReservations(newReservations)

    services.updateReservationItem(newReservations[i]['orderItem'], {
      firstname: newReservations[i]['name'],
      lastname: newReservations[i]['surname'],
      weight: newReservations[i]['weight']
    })

  }

  let handleReservantChange = ( e: any ) => {

    let newReservant = {...reservant};

    if( e.target.name == 'reservant_name' ){
      newReservant['firstname'] = e.target.value
    }if( e.target.name == 'reservant_surname' ){
      newReservant['lastname'] = e.target.value
    }if( e.target.name == 'reservant_email' ){
      newReservant['email'] = e.target.value
    }if( e.target.name == 'reservant_phone' ){
      newReservant['phone'] = e.target.value
    }

    setReservant(newReservant)

    localStorage.setItem('bk_reservant', JSON.stringify(newReservant))

  }

  let addFormFields = () => {

      setReservations([...reservations, { orderItem: "", ticket: "", ticket_state: "err", ticket_data_state: "err", ticket_message: "Chybějící nebo chybná letenka", name: "", surname: "", weight : "" }])

  }

  let removeFormFields = (i: number) => {

      let newReservations = [...reservations];
      newReservations.splice(i, 1);

      // localStorage.setItem('bk_reservations', JSON.stringify(newReservations));

      setReservations(newReservations)

  }

  let handleSubmit = (event: any) => {

      event.preventDefault();

      let error = false;

      let newReservations = [...reservations];

      newReservations.forEach((element, index) => {

        if( reservantState.reservant_state == 'err' || element.ticket_state == 'err' || element.weight == '' || element.name == '' || element.surname == '' ){

          console.log('Chyba letenky')

          error = true

          setNotification(<Notification text={ "Rezervace není kompletní"}/>)

        }

      })

      setReservations(newReservations)

      if( !error ){


        navigate('/reservation-confirm',{state:{reservant,reservations,term:id}});

      }

  }

  const steps = [

    {'name':'Obchod', 'link':'/term-list', 'active': true},
    {'name':'Košík','link': '/passenger-list', 'active': false},
    {'name':'Pokladna','link': '/reservation-confirm', 'active': true},

  ];

  return (

    <div>

    <div className="container">
    {notification}
    </div>

    <ShopHeader title="Rezervace letenek" image="http://balony.techcrowd.cz/reservation.jpg"/>

    <div className="container py-5">

    <Steps links={steps} />

    <div className="card border-0 custom-shadow custom-radius col-12 col-lg-9 mx-auto">
    <div className="card-body p-5">

    <div className="mb-5">

    <div className="fs-2 montserrat">Informace o rezervujícím</div>
    <small>Rezervujícího budeme kontaktovat</small>

    <div className="fs-5 text-primary my-3 montserrat">{reservantState.reservant_message}</div>

      <div className="row g-4">
        <div className="col-12 col-lg-6">
          <input className="form-control form-control-lg form-control-bg border-0" type="text" name="reservant_name" placeholder="Jméno rezervujícího" value={reservant.firstname} onChange={ (e) => handleReservantChange(e) }/>
        </div>
        <div className="col-12 col-lg-6">
          <input className="form-control form-control-lg form-control-bg border-0" type="text" name="reservant_surname" placeholder="Příjmení rezervujícího" value={reservant.lastname} onChange={ (e) => handleReservantChange(e) }/>
        </div>
        <div className="col-12 col-lg-6">
          <input className="form-control form-control-lg form-control-bg border-0" type="text" name="reservant_email" placeholder="Email rezervujícího" value={reservant.email} onChange={ (e) => handleReservantChange(e) } />
          {validator.email}
        </div>
        <div className="col-12 col-lg-6">
          <input className="form-control form-control-lg form-control-bg border-0" type="text" name="reservant_phone" placeholder="Telefon rezervujícího" value={reservant.phone} onChange={ (e) => handleReservantChange(e) }/>
          {validator.phone}
        </div>
      </div>

    </div>

    <div className="">

      <div className="fs-2 montserrat">Rezervace letenek</div>
        {reservationsList}
        <form  onSubmit={handleSubmit}>
          {reservations.map((element, index) => (
            <div className="row my-3 g-4" key={index}>
            <div className="fs-3 montserrat">{index+1}. letenka</div>
            <div className={`fs-5 text-primary montserrat ${element.ticket_data_state === 'err' || element.ticket_state === 'err' ? "text-danger" : "text-success"}`}>{element.ticket_message}</div>
              <div className="col-12 col-lg-5">
                <input className="form-control form-control-lg form-control-bg border-0" type="text" name="ticket" placeholder="Číslo letenky" value={element.ticket} onChange={ (e) => handleTicket(index, e) } />
              </div>
              <div className="col-12 col-lg-5">
                <input className="form-control form-control-lg form-control-bg border-0" type="number" name="weight" placeholder="Hmotnost" value={element.weight} onChange={ (e) => handleChange(index, e) }/>
              </div>
              <div className="col-12 col-lg-5">
                <input className="form-control form-control-lg form-control-bg border-0" type="text" name="name" placeholder="Jméno" value={element.name} onChange={ (e) => handleChange(index, e) }/>
              </div>
              <div className="col-12 col-lg-5">
                <input className="form-control form-control-lg form-control-bg border-0" type="text" name="surname" placeholder="Příjmení" value={element.surname} onChange={ (e) => handleChange(index, e) }/>
              </div>
              {
                index ?
                  <div className="col-12 col-lg-2 d-flex justify-content-end">
                    <button type="button"  className="btn btn-link text-danger" onClick={() => removeFormFields(index)}><i className="fa-regular fa-circle-xmark fa-2xl"></i></button>
                  </div>
                : null
              }
              <hr />
            </div>
          ))}
          <div className="button-section">
              <button className="btn btn-lg btn-outline-primary rounded-pill my-3 me-3 add" type="button" onClick={() => addFormFields()}><i className="fa-solid fa-user-plus"></i> Přidat letenku</button>
              <button className={"btn btn-lg btn-outline-primary rounded-pill my-3 submit " + buttonState} type="submit"><i className="fa-solid fa-check"></i> Potvrdit</button>
          </div>
      </form>

    </div>

    </div>
    </div>
    </div>
    </div>

  )

}

export default PassengerList
